<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { querystring, push } from 'svelte-spa-router';
	//Helpers
	import { parseQuerystring } from 'src/helpers/utilities';
	//Design system components
	import { Container, Toolbar, Breadcrumbs } from '@Shelly/shelly-design-system';
	//App components
	import LoqedCredentials from 'src/components/Integrations/Loqed/LoqedCredentials.svelte';
	import LoqedListDevices from 'src/components/Integrations/Loqed/LoqedListDevices.svelte';

	let associated: boolean = false; // flag if the Oauth process is successful
	// remove
	console.log('Loqed Integration querystring: ', $querystring);
	let { state } = parseQuerystring($querystring);
	state = decodeURIComponent(state);

	if (typeof state !== undefined) {
		const loqedHash = localStorage.getItem('loqedHash');
		if (typeof loqedHash !== undefined && loqedHash === state) {
			associated = true;
			localStorage.removeItem('loqedHash');
		}
	}
</script>

<Toolbar class="mb-m">
	<Breadcrumbs
		aria-label={$format('label_loqed', { default: 'LOQED' })}
		slot="breadcrumbs"
		links={[
			{ label: 'Integrations', onClick: () => push('/settings/integrations') },
			{ label: 'LOQED' },
		]}
	/>
</Toolbar>

{#if !associated}
	<Container class="mb-s" noScroll>
		<LoqedCredentials />
	</Container>
{:else}
	<Container class="mb-s" noScroll>
		<LoqedListDevices />
	</Container>
{/if}
